export const languages = [
  {
    value: 'ja',
    label: '日本語'
  },
  {
    value: 'en',
    label: '英語'
  },
  {
    value: 'zh',
    label: '中国語'
  }
];
export const languageType = {
  ORIGIN: 'ja'
};

export const otherLanguages = [
  {
    translateType: 0,
    language: 'en'
  },
  {
    translateType: 0,
    language: 'zh'
  }
];
